/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyThirdPartyViewModel } from './CompanyThirdPartyViewModel';
import {
    CompanyThirdPartyViewModelFromJSON,
    CompanyThirdPartyViewModelFromJSONTyped,
    CompanyThirdPartyViewModelToJSON,
} from './CompanyThirdPartyViewModel';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPTHIRDPARTYRELATIONTYPE } from './IAPTHIRDPARTYRELATIONTYPE';
import {
    IAPTHIRDPARTYRELATIONTYPEFromJSON,
    IAPTHIRDPARTYRELATIONTYPEFromJSONTyped,
    IAPTHIRDPARTYRELATIONTYPEToJSON,
} from './IAPTHIRDPARTYRELATIONTYPE';
import type { IndividualThirdPartyViewModel } from './IndividualThirdPartyViewModel';
import {
    IndividualThirdPartyViewModelFromJSON,
    IndividualThirdPartyViewModelFromJSONTyped,
    IndividualThirdPartyViewModelToJSON,
} from './IndividualThirdPartyViewModel';
import type { NonTaxableInstitutionThirdPartyViewModel } from './NonTaxableInstitutionThirdPartyViewModel';
import {
    NonTaxableInstitutionThirdPartyViewModelFromJSON,
    NonTaxableInstitutionThirdPartyViewModelFromJSONTyped,
    NonTaxableInstitutionThirdPartyViewModelToJSON,
} from './NonTaxableInstitutionThirdPartyViewModel';
import type { TrustThirdPartyViewModel } from './TrustThirdPartyViewModel';
import {
    TrustThirdPartyViewModelFromJSON,
    TrustThirdPartyViewModelFromJSONTyped,
    TrustThirdPartyViewModelToJSON,
} from './TrustThirdPartyViewModel';

/**
 * 
 * @export
 * @interface ThirdPartyViewModel
 */
export interface ThirdPartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof ThirdPartyViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {number}
     * @memberof ThirdPartyViewModel
     */
    externalPartyId?: number;
    /**
     * 
     * @type {number}
     * @memberof ThirdPartyViewModel
     */
    thirdPartyRelationId?: number;
    /**
     * 
     * @type {IAPTHIRDPARTYRELATIONTYPE}
     * @memberof ThirdPartyViewModel
     */
    thirdPartyRelationTypeId?: IAPTHIRDPARTYRELATIONTYPE;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof ThirdPartyViewModel
     */
    partyTypeId?: IAPPARTYTYPE;
    /**
     * 
     * @type {number}
     * @memberof ThirdPartyViewModel
     */
    percentageAllocation?: number;
    /**
     * 
     * @type {IndividualThirdPartyViewModel}
     * @memberof ThirdPartyViewModel
     */
    individualThirdParty?: IndividualThirdPartyViewModel;
    /**
     * 
     * @type {TrustThirdPartyViewModel}
     * @memberof ThirdPartyViewModel
     */
    trustThirdParty?: TrustThirdPartyViewModel;
    /**
     * 
     * @type {CompanyThirdPartyViewModel}
     * @memberof ThirdPartyViewModel
     */
    companyThirdParty?: CompanyThirdPartyViewModel;
    /**
     * 
     * @type {NonTaxableInstitutionThirdPartyViewModel}
     * @memberof ThirdPartyViewModel
     */
    nonTaxableInstitutionThirdParty?: NonTaxableInstitutionThirdPartyViewModel;
}

/**
 * Check if a given object implements the ThirdPartyViewModel interface.
 */
export function instanceOfThirdPartyViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ThirdPartyViewModelFromJSON(json: any): ThirdPartyViewModel {
    return ThirdPartyViewModelFromJSONTyped(json, false);
}

export function ThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'externalPartyId': !exists(json, 'ExternalPartyId') ? undefined : json['ExternalPartyId'],
        'thirdPartyRelationId': !exists(json, 'ThirdPartyRelationId') ? undefined : json['ThirdPartyRelationId'],
        'thirdPartyRelationTypeId': !exists(json, 'ThirdPartyRelationTypeId') ? undefined : IAPTHIRDPARTYRELATIONTYPEFromJSON(json['ThirdPartyRelationTypeId']),
        'partyTypeId': !exists(json, 'PartyTypeId') ? undefined : IAPPARTYTYPEFromJSON(json['PartyTypeId']),
        'percentageAllocation': !exists(json, 'PercentageAllocation') ? undefined : json['PercentageAllocation'],
        'individualThirdParty': !exists(json, 'IndividualThirdParty') ? undefined : IndividualThirdPartyViewModelFromJSON(json['IndividualThirdParty']),
        'trustThirdParty': !exists(json, 'TrustThirdParty') ? undefined : TrustThirdPartyViewModelFromJSON(json['TrustThirdParty']),
        'companyThirdParty': !exists(json, 'CompanyThirdParty') ? undefined : CompanyThirdPartyViewModelFromJSON(json['CompanyThirdParty']),
        'nonTaxableInstitutionThirdParty': !exists(json, 'NonTaxableInstitutionThirdParty') ? undefined : NonTaxableInstitutionThirdPartyViewModelFromJSON(json['NonTaxableInstitutionThirdParty']),
    };
}

export function ThirdPartyViewModelToJSON(value?: ThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'ExternalPartyId': value.externalPartyId,
        'ThirdPartyRelationId': value.thirdPartyRelationId,
        'ThirdPartyRelationTypeId': IAPTHIRDPARTYRELATIONTYPEToJSON(value.thirdPartyRelationTypeId),
        'PartyTypeId': IAPPARTYTYPEToJSON(value.partyTypeId),
        'PercentageAllocation': value.percentageAllocation,
        'IndividualThirdParty': IndividualThirdPartyViewModelToJSON(value.individualThirdParty),
        'TrustThirdParty': TrustThirdPartyViewModelToJSON(value.trustThirdParty),
        'CompanyThirdParty': CompanyThirdPartyViewModelToJSON(value.companyThirdParty),
        'NonTaxableInstitutionThirdParty': NonTaxableInstitutionThirdPartyViewModelToJSON(value.nonTaxableInstitutionThirdParty),
    };
}

